import { useEffect } from 'react';
import { useGetMenu } from 'api/menu';
import useConfig from 'hooks/useConfig';
import { PresetColor, FontFamily } from 'types/config';

export default function ThemeSync() {
  const { libraries, selectedLibrary, menuLoading } = useGetMenu();
  const { presetColor, fontFamily, setLibraryTheme } = useConfig();

  useEffect(() => {
    if (!menuLoading && libraries && selectedLibrary) {
      const activeLib = libraries.find(
        (lib: { id: number | string; name: string; themeColor?: string; fontFamily?: string }) => Number(lib.id) === Number(selectedLibrary)
      );
      if (activeLib) {
        const dbTheme = (activeLib.themeColor || 'default') as PresetColor;
        const dbFont = (activeLib.fontFamily || `'Public Sans', sans-serif`) as FontFamily;

        if (presetColor !== dbTheme || fontFamily !== dbFont) {
          setLibraryTheme(dbTheme, dbFont);
        }
      }
    }
  }, [menuLoading, libraries, selectedLibrary, presetColor, fontFamily, setLibraryTheme]);

  return null;
}
